import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-rq',
  template: "<span *ngIf='!isReadOnly' class=\"aml-rq-red\"> *</span>"
})
export class RqComponent {
  @Input() isReadOnly = false;
}
